import React from 'react';
import { motion } from 'framer-motion';

const rarityColors = {
  common: 'from-gray-500/20 to-gray-400/10 border-gray-400/20',
  uncommon: 'from-green-500/20 to-green-400/10 border-green-400/20',
  rare: 'from-blue-500/20 to-blue-400/10 border-blue-400/20',
  epic: 'from-purple-500/20 to-purple-400/10 border-purple-400/20',
  legendary: 'from-orange-500/20 to-orange-400/10 border-orange-400/20',
  mythic: 'from-gold-500/20 to-gold-400/10 border-gold-400/20',
  icon_series: 'from-cyan-500/20 to-cyan-400/10 border-cyan-400/20',
  gaming_legends: 'from-indigo-500/20 to-indigo-400/10 border-indigo-400/20',
  marvel: 'from-red-500/20 to-red-400/10 border-red-400/20',
  dc: 'from-blue-700/20 to-blue-600/10 border-blue-600/20',
  star_wars: 'from-blue-900/20 to-blue-800/10 border-blue-800/20',
};

const ShopItem = ({ item }) => {
  const rarity = item.rarity?.value?.toLowerCase() || 'common';
  const colorClass = rarityColors[rarity] || rarityColors.common;

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ y: -5 }}
      className={`glass-card overflow-hidden flex flex-col group border ${colorClass.split(' ').pop()}`}
    >
      <div className={`relative aspect-square bg-gradient-to-br ${colorClass.split(' ').slice(0, 2).join(' ')}`}>
        <img 
          src={item.images?.featured || item.images?.icon} 
          alt={item.name}
          className="w-full h-full object-contain p-4 group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute bottom-2 right-2 bg-black/60 backdrop-blur-md px-2 py-1 rounded text-xs font-bold flex items-center gap-1">
          <img src="https://fortnite-api.com/assets/vbuck.png" alt="v-bucks" className="w-3 h-3" />
          {item.price}
        </div>
      </div>
      <div className="p-4 flex-1">
        <h4 className="text-lg font-bold truncate">{item.name}</h4>
        <p className="text-sm text-white/40 line-clamp-2 mt-1">{item.description}</p>
        <span className="inline-block mt-3 px-2 py-0.5 rounded-full bg-white/5 text-[10px] font-bold uppercase tracking-widest text-white/60 border border-white/10">
          {item.type?.displayValue}
        </span>
      </div>
    </motion.div>
  );
};

export default ShopItem;
